import React from 'react';

import * as ProcessSchemasDAO from 'processes/dao/ProcessSchemaDAO';

import EmptySidebarIcon from './EmptySidebarIcon';
import {Section, SettingsSection} from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface ProcessSchemaSettingsProps {
  section: SettingsSection;
}

export default function ProcessSchemaSettings(props: ProcessSchemaSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Workflow Schemas</div>
      <SidebarItem
        active={props.section === Section.PROCESS_SCHEMAS}
        icon={<EmptySidebarIcon />}
        name="Task schemas"
        link={ProcessSchemasDAO.processTaskSchemasURL()}
      />
    </div>
  );
}
